module.exports = __webpack_public_path__ + "static/media/software-blue-diamond.b90b3060.svg";